import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=06375bb0"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=06375bb0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports